import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAppstore = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 14 14",
	xmlSpace: "preserve",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		transform: "translate(929 308)",
		children: /* @__PURE__ */ _jsx("g", {
			transform: "translate(-929 -308)",
			children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
				d: "M1.9,5.1c-1.2,2.1-0.4,5.2,0.9,7.1C3.4,13.2,4.1,14,5,14H5c0.4,0,0.7-0.1,1-0.3 c0.4-0.2,0.8-0.3,1.2-0.3c0.4,0,0.8,0.1,1.2,0.3C8.8,13.9,9.2,14,9.5,14c1,0,1.6-0.9,2.2-1.7c0.4-0.6,0.7-1.3,1-2v0 c0-0.1,0-0.1-0.1-0.1h0c-1.1-0.5-1.8-1.5-1.8-2.7c0-1,0.6-2,1.4-2.5l0,0c0.1,0,0.1-0.1,0-0.2c0,0,0,0,0,0 c-0.6-0.9-1.6-1.4-2.6-1.4c-0.1,0-0.2,0-0.2,0c-0.6,0-1.1,0.2-1.6,0.4C7.6,3.9,7.4,3.9,7.1,4c-0.3,0-0.6-0.1-0.8-0.2 C5.8,3.5,5.3,3.4,4.9,3.4h0C3.6,3.4,2.5,4.1,1.9,5.1",
				fill: "currentColor"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M9.7,0C8.9,0.1,8.2,0.5,7.6,1.1C7.1,1.7,6.8,2.5,6.9,3.3c0,0.1,0,0.1,0.1,0.1 c0,0,0.1,0,0.1,0c0.8,0,1.5-0.4,2-1c0.5-0.6,0.8-1.5,0.7-2.3C9.8,0,9.8,0,9.7,0",
				fill: "currentColor"
			})] }) })
		})
	})
});
export { SvgAppstore as ReactComponent };
